import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import axios from 'axios';
import { Toaster } from '@/components/ui/sonner';
import Home from './pages/Home';
import ComingSoon from './pages/ComingSoon';
import ShareHelper from './pages/ShareHelper';
import AboutUs from './pages/AboutUs';
import CreatorStore from './pages/CreatorStore';
import ProductDetail from './pages/ProductDetail';
import CreatorDashboard from './pages/CreatorDashboard';
import BuyerProfile from './pages/BuyerProfile';
import Checkout from './pages/Checkout';
import CheckoutSuccess from './pages/CheckoutSuccess';
import MyPurchases from './pages/MyPurchases';
import ResetPassword from './pages/ResetPassword';
import SetPassword from './pages/SetPassword';
import MarketplacePreview from './pages/MarketplacePreview';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import FAQs from './pages/FAQs';
import ContactUs from './pages/ContactUs';
import AdminDashboard from './pages/AdminDashboard';
import Messages from './pages/Messages';
import AuthCallback from './pages/AuthCallback';
import ChatRooms from './pages/ChatRooms';
import FloatingChatbot from './components/FloatingChatbot';
import ScoutFloatingButton from './components/ScoutFloatingButton';
import Discover from './pages/Discover';
import CookieConsent from './components/CookieConsent';
import ScrollRestoration from './components/ScrollRestoration';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import EmailCapturePopup from './components/EmailCapturePopup';
import { registerServiceWorker } from './utils/pwaUtils';
// New backlog features
import Wishlist from './pages/Wishlist';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import SellerAnalytics from './pages/SellerAnalytics';
import AffiliatePayouts from './pages/AffiliatePayouts';
import AffiliateProgram from './pages/AffiliateProgram';
import MyDisputes from './pages/MyDisputes';
import SellerDisputes from './pages/SellerDisputes';
import MySubscriptions from './pages/MySubscriptions';
import ReferralDashboard from './pages/ReferralDashboard';
import Resources from './pages/Resources';
import CreatorBadge from './pages/CreatorBadge';
import CreatorLeaderboard from './pages/CreatorLeaderboard';
// Admin Console Pages
import AdminOverview from './pages/admin/AdminOverview';
import AdminFraud from './pages/admin/AdminFraud';
import AdminDisputes from './pages/admin/AdminDisputes';
import AdminRefunds from './pages/admin/AdminRefunds';
import AdminAuditLogs from './pages/admin/AdminAuditLogs';
import AdminSecurityBlockedIPs from './pages/admin/AdminSecurityBlockedIPs';
import NewsletterPreferences from './pages/NewsletterPreferences';import AdminCreatorHealth from './pages/admin/AdminCreatorHealth';
import AdminLeadFinder from './pages/admin/AdminLeadFinder';
import AdminClickAnalytics from './pages/admin/AdminClickAnalytics';
import AdminHealthChecks from './pages/admin/AdminHealthChecks';
import AdminLifecycleEmails from './pages/admin/AdminLifecycleEmails';
import AdminPlaybooks from './pages/admin/AdminPlaybooks';
import AdminVettingLog from './pages/admin/AdminVettingLog';
import AdminManualPayouts from './pages/admin/AdminManualPayouts';
import DocsWebhooks from './pages/DocsWebhooks';
import ApiCreatorQuickstart from './pages/ApiCreatorQuickstart';
import AdminEmailDelivery from './pages/admin/AdminEmailDelivery';
import AdminCheckoutFailures from './pages/admin/AdminCheckoutFailures';
import AdminPartnerApplications from './pages/admin/AdminPartnerApplications';
import AdminProspects from './pages/admin/AdminProspects';
import AdminAffiliatePartners from './pages/admin/AdminAffiliatePartners';
import AdminSpotlightCalendar from './pages/admin/AdminSpotlightCalendar';
import AdminPartnerRevenue from './pages/admin/AdminPartnerRevenue';
import AdminInventorNotebook from './pages/admin/AdminInventorNotebook';
import AdminPlatformPartners from './pages/admin/AdminPlatformPartners';
import AdminOutreach from './pages/admin/AdminOutreach';
import AdminUpgradeCandidates from './pages/admin/AdminUpgradeCandidates';
import AdminOutreachLog from './pages/admin/AdminOutreachLog';
import AdminSEOAudits from './pages/admin/AdminSEOAudits';
import AdminCommissionFeed from './pages/admin/AdminCommissionFeed';
import AdminBuildPartnerApplications from './pages/admin/AdminBuildPartnerApplications';
import AdminOptimizerFunnel from './pages/admin/AdminOptimizerFunnel';
import AdminMemes from './pages/admin/AdminMemes';
import AdminCompliance from './pages/admin/AdminCompliance';
import AdminInfluencers from './pages/admin/AdminInfluencers';
import AdminAvatarTool from './pages/admin/AdminAvatarTool';
import AdminProductImageTool from './pages/admin/AdminProductImageTool';
import AdminUserMergeTool from './pages/admin/AdminUserMergeTool';
import AdminDataSyncTool from './pages/admin/AdminDataSyncTool';
import AdminHouseProductsWeekly from './pages/admin/AdminHouseProductsWeekly';
import AdminProductManager from './pages/admin/AdminProductManager';
import AdminFixNeonProducts from './pages/admin/AdminFixNeonProducts';
import AdminShareCards from './pages/admin/AdminShareCards';
import AdminWave2Ops from './pages/admin/AdminWave2Ops';
import InfluencerRedirect from './pages/InfluencerRedirect';
import FounderAffiliateAgreement from './pages/FounderAffiliateAgreement';
import BrandedSlugFallback from './components/BrandedSlugFallback';
import LaunchDayBar from './components/LaunchDayBar';
import InfluencerLogin from './pages/InfluencerLogin';
import InfluencerDashboard from './pages/InfluencerDashboard';
import BuildPartnersApply from './pages/BuildPartnersApply';
import Optimizer from './pages/Optimizer';
import PartnersPlatforms from './pages/PartnersPlatforms';
import PartnersPlatformsApply from './pages/PartnersPlatformsApply';
import PlatformPartnerStats from './pages/PlatformPartnerStats';
import Press from './pages/Press';
import Security from './pages/Security';
import LegalDMCA from './pages/LegalDMCA';
import PrivacyRequestMyData from './pages/PrivacyRequestMyData';
import InAppBrowserBanner from './components/InAppBrowserBanner';
import { safeGetJSON } from './utils/safeStorage';
import AffiliateGoRedirect from './pages/AffiliateGoRedirect';
import QrPostcardRedirect from './pages/QrPostcardRedirect';
import AdminQRCodes from './pages/AdminQRCodes';
import AffiliatePartnerStore from './pages/AffiliatePartnerStore';
import FeaturedDirectory from './pages/FeaturedDirectory';
import WeeklyDigest from './pages/WeeklyDigest';
import WeeklyDigestIndex from './pages/WeeklyDigestIndex';
import PartnerApply from './pages/PartnerApply';
import PartnerDashboard from './pages/PartnerDashboard';
import Partners from './pages/Partners';
import Submit from './pages/Submit';
import ProductHuntLanding from './pages/ProductHuntLanding';
import ErrorBoundary from './components/ErrorBoundary';

// Site mode is controlled from Admin Dashboard
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

axios.defaults.baseURL = API;
axios.defaults.withCredentials = true;

/**
 * Smart /dashboard router — routes partners to /partner-dashboard,
 * everyone else to the standard CreatorDashboard. Reads account_type
 * from the cached user object in localStorage (set at login) so there's
 * no auth round-trip. Non-authed users are handled inside CreatorDashboard.
 */
function DashboardRouter() {
  try {
    const rawUser = localStorage.getItem('user');
    if (rawUser) {
      const u = JSON.parse(rawUser);
      const accountType = (u?.account_type || '').toLowerCase();
      if (accountType === 'partner' || u?.is_partner === true) {
        return <Navigate to="/partner-dashboard" replace />;
      }
    }
  } catch (err) {
    console.debug('DashboardRouter: could not parse cached user', err?.message || err);
  }
  return <CreatorDashboard />;
}

/**
 * Defensive URL rewriter:
 * If the frontend bundle was built with a stale/misconfigured
 * REACT_APP_BACKEND_URL (e.g. a preview host like
 * `aimarket-22.emergent.host`) but it is now served from a different
 * production custom domain (e.g. `theailedger.ai`), every cross-origin
 * API call will be blocked by CORS and can cause the app to render a
 * black screen. This interceptor rewrites such URLs to same-origin at
 * request time, so the app keeps working even if the deploy-time env
 * var is wrong. On localhost / *.emergentagent.com / *.emergent.host
 * we trust the env var and do nothing.
 */
function shouldRewriteToSameOrigin() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return false;
  if (host.endsWith('.emergentagent.com')) return false;
  if (host.endsWith('.emergent.host')) return false;
  return true;
}

function rewriteIfNeeded(url) {
  if (!url || typeof url !== 'string') return url;
  if (!shouldRewriteToSameOrigin()) return url;
  try {
    const u = new URL(url, window.location.origin);
    if (u.host !== window.location.host) {
      // Preserve path + query, move to same origin
      return window.location.origin + u.pathname + u.search + u.hash;
    }
    return url;
  } catch (_) {
    return url;
  }
}

// Override axios baseURL at runtime on custom production domains
if (shouldRewriteToSameOrigin()) {
  axios.defaults.baseURL = `${window.location.origin}/api`;
}

axios.interceptors.request.use(
  (config) => {
    if (config.url) {
      config.url = rewriteIfNeeded(config.url);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Also patch the global fetch() for the few places that bypass axios
// (e.g. ComingSoon.js launch-date fetch).
if (typeof window !== 'undefined' && window.fetch && !window.__fetchPatched) {
  const _origFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    try {
      if (typeof input === 'string') {
        input = rewriteIfNeeded(input);
      } else if (input && typeof input === 'object' && 'url' in input) {
        const newUrl = rewriteIfNeeded(input.url);
        if (newUrl !== input.url) {
          input = new Request(newUrl, input);
        }
      }
    } catch (_) { /* ignore and pass through */ }
    return _origFetch(input, init);
  };
  window.__fetchPatched = true;
}

// Add axios interceptor to include session token in requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Postcard QR attribution interceptor. If the visitor scanned a
// postcard QR within the last 30 days (localStorage `tal_qr_attribution`,
// written by /qr/:slug or by the homepage `?qr=` fallback), forward the
// slug as `X-QR-Slug` on every API request. Backend stamps the slug on
// user signup + order docs so the admin QR stats can attribute downstream
// conversions back to the mailing batch.
axios.interceptors.request.use(
  (config) => {
    try {
      const raw = localStorage.getItem('tal_qr_attribution');
      if (raw) {
        const rec = JSON.parse(raw);
        if (rec && rec.slug && (!rec.expires_at || Date.now() < Date.parse(rec.expires_at))) {
          config.headers['X-QR-Slug'] = rec.slug;
        }
      }
    } catch (_) { /* ignore */ }
    return config;
  },
  (error) => Promise.reject(error)
);

// Analytics tracking hook
function useAnalytics() {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view on route change
    const trackPageView = async () => {
      try {
        // Get or create visitor ID from localStorage
        let visitorId = localStorage.getItem('visitor_id');
        
        // Capture UTM parameters from URL
        const searchParams = new URLSearchParams(location.search);
        const utmParams = {
          utm_source: searchParams.get('utm_source'),
          utm_medium: searchParams.get('utm_medium'),
          utm_campaign: searchParams.get('utm_campaign'),
          utm_content: searchParams.get('utm_content'),
          utm_term: searchParams.get('utm_term')
        };
        
        // Store UTM params in session if present (for conversion tracking)
        if (utmParams.utm_source) {
          sessionStorage.setItem('utm_params', JSON.stringify(utmParams));
        }
        
        // Get stored UTM params if not in current URL
        const storedUtm = sessionStorage.getItem('utm_params');
        const finalUtm = utmParams.utm_source ? utmParams : (storedUtm ? JSON.parse(storedUtm) : {});
        
        const response = await axios.post('/analytics/track', {
          event_type: 'page_view',
          page: location.pathname,
          referrer: document.referrer || null,
          user_agent: navigator.userAgent,
          ...finalUtm
        }, {
          withCredentials: true  // Include cookies
        });
        
        // Store visitor_id from response if it's a new one
        if (response.data?.visitor_id && response.data?.is_new) {
          localStorage.setItem('visitor_id', response.data.visitor_id);
        }
      } catch (error) {
        // Silent fail for analytics
        console.debug('Analytics tracking failed:', error);
      }
    };
    
    trackPageView();
  }, [location.pathname, location.search]);
}

function AppRouter() {
  const location = useLocation();
  const [siteMode, setSiteMode] = useState(null);
  const [checkingMode, setCheckingMode] = useState(true);
  const [previewAccess, setPreviewAccess] = useState(
    () => (typeof window !== 'undefined' && window.sessionStorage?.getItem('previewAccess') === 'true')
  );
  const [authTick, setAuthTick] = useState(0);
  
  // Track page views
  useAnalytics();

  // Re-render on auth changes triggered by login/logout (replaces hard reload)
  useEffect(() => {
    const bump = () => setAuthTick((t) => t + 1);
    window.addEventListener('auth-changed', bump);
    window.addEventListener('storage', bump);
    return () => {
      window.removeEventListener('auth-changed', bump);
      window.removeEventListener('storage', bump);
    };
  }, []);

  // Stitch PostHog identity to whoever is currently logged in. Runs on
  // every auth change (login, logout, profile update) so anonymous
  // pageviews from before login get linked to the user's email and
  // post-logout events get a fresh anonymous id. No-op when PostHog
  // isn't configured (initPosthog returned null in index.js).
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { identifyPosthog } = await import('./analytics/posthogClient');
        if (cancelled) return;
        const raw = localStorage.getItem('user');
        const user = raw ? JSON.parse(raw) : null;
        identifyPosthog(user);
      } catch {
        // PostHog client missing or localStorage parse failed — ignore,
        // we don't want analytics issues to break the app.
      }
    })();
    return () => { cancelled = true; };
  }, [authTick]);

  // Check site mode on load
  useEffect(() => {
    const checkSiteMode = async () => {
      try {
        const response = await axios.get('/site-mode');
        setSiteMode(response.data.mode);
      } catch (error) {
        // Default to live if can't fetch
        setSiteMode('live');
      } finally {
        setCheckingMode(false);
      }
    };
    checkSiteMode();
  }, []);

  // Pre-launch preview-link bypass:
  //   ?preview=<token>  →  POST/GET to /api/preview-access/verify  →
  //   if valid, set sessionStorage flag and re-render so the
  //   ComingSoon gate falls through to the full marketplace.
  // No account, no Founding Creator counter, no CRM record. The flag
  // lives in sessionStorage (per-tab, cleared on tab close) so it
  // doesn't leak between unrelated browser sessions on shared devices.
  useEffect(() => {
    if (previewAccess) return; // already granted this session
    const params = new URLSearchParams(window.location.search);
    const token = params.get('preview');
    if (!token) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get('/preview-access/verify', { params: { token } });
        if (!cancelled && res.data?.valid) {
          try { window.sessionStorage.setItem('previewAccess', 'true'); } catch {}
          setPreviewAccess(true);
          // Strip the token from the URL so it isn't shared by accident
          // (e.g. screenshot, paste of address bar) — the sessionStorage
          // flag is what now grants access for the remainder of the tab.
          try {
            const url = new URL(window.location.href);
            url.searchParams.delete('preview');
            window.history.replaceState({}, '', url.toString());
          } catch {}
        }
      } catch {
        // Silent — invalid tokens just hit the ComingSoon gate like everyone else.
      }
    })();
    return () => { cancelled = true; };
  }, [previewAccess]);

  // Sub-Affiliate recruiter link capture. Founding Creators share a link
  // shaped `theailedger.ai/?af=<their_referral_code>`. On first page load
  // with an `?af=` param we stash the code in localStorage; the value
  // sits there until the visitor signs up, at which point AuthModal
  // forwards it to /auth/register and it's cleared. Survives tab close
  // (unlike preview tokens) because visitors often click the link, browse,
  // close the tab, and come back days later to sign up. Also fires a
  // server-side click tracker so the recruiter sees clicks → signups
  // attribution in their Sub-Affiliates dashboard.
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const af = params.get('af');
      if (!af) return;
      const existing = localStorage.getItem('incoming_af');
      // First-touch attribution: don't overwrite if they already have an
      // af code from a previous visit. Whoever recruited them first wins.
      if (!existing) {
        localStorage.setItem('incoming_af', af);
      }
      // Fire-and-forget click tracker so the FC's dashboard reflects clicks.
      axios.post('/sub-affiliate/track-visit', { af_code: af }).catch(() => {});
      // Clean the URL so the `?af=` doesn't follow the user around the
      // SPA in every subsequent link share (and so it doesn't end up in
      // analytics reports).
      try {
        const url = new URL(window.location.href);
        url.searchParams.delete('af');
        window.history.replaceState({}, '', url.toString());
      } catch {}
    } catch {
      // Silent — a broken localStorage or malformed URL must never
      // crash the entire app shell.
    }
  }, []);

  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  // Show loading while checking mode
  if (checkingMode) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-[#00F0FF] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  // If in Coming Soon mode, gate access based on user role
  // INTENTIONAL CLIENT-REQUIRED BEHAVIOR:
  // Admin, Creator, and Seller accounts MUST be able to preview the full marketplace
  // (including homepage, product pages, store pages) during pre-launch.
  // Public/unauthenticated users see the Coming Soon countdown page.
  if (siteMode === 'coming_soon') {
    // authTick re-read trigger - see useEffect below
    const _tick = authTick; // eslint-disable-line no-unused-vars
    const isLoggedIn = localStorage.getItem('token');
    const user = safeGetJSON('user', null);
    const userRole = user?.role?.toLowerCase() || '';
    const userEmail = user?.email?.toLowerCase() || '';
    
    // Roles that can preview the full marketplace during pre-launch
    const canPreviewMarketplace = previewAccess || (isLoggedIn && (
      userRole === 'admin' ||
      userRole === 'creator' ||
      userRole === 'seller' ||
      userEmail === 'ailedgerllc@gmail.com'
    ));

    // Public paths accessible to everyone (no login required)
    const publicPaths = ['/terms', '/privacy', '/refund-policy', '/faqs', '/contact', '/about', '/admin', '/resources', '/set-password', '/reset-password', '/badge', '/leaderboard', '/partners', '/build-partners', '/submit', '/sell', '/list', '/apply', '/go/', '/featured', '/creators/product-hunt', '/share-helper', '/docs', '/press', '/optimizer', '/security', '/legal', '/r/', '/influencer', '/weekly', '/preferences'];
    const isPublicPath = publicPaths.some(path => location.pathname.startsWith(path));
    
    // Paths that any logged-in user can access (not just admin/creator)
    const authRequiredPaths = ['/dashboard', '/profile', '/messages', '/checkout', '/my-purchases', '/seller', '/my-disputes', '/chat', '/creator', '/affiliate', '/referrals'];
    const isAuthPath = authRequiredPaths.some(path => location.pathname.startsWith(path));

    // Admin/Creator/Seller bypass: render full route set (marketplace preview)
    if (canPreviewMarketplace) {
      // Fall through to the full route set below (line ~217)
    }
    // Public paths: accessible to everyone
    else if (isPublicPath) {
      return (
        <Routes>
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/about" element={<AboutUs />} />
          {/* Admin Console Routes */}
          <Route path="/admin" element={<AdminOverview />} />
          <Route path="/admin/fraud" element={<AdminFraud />} />
          <Route path="/admin/disputes" element={<AdminDisputes />} />
          <Route path="/admin/refunds" element={<AdminRefunds />} />
          <Route path="/admin/audit-logs" element={<AdminAuditLogs />} />
          <Route path="/admin/security/blocked-ips" element={<AdminSecurityBlockedIPs />} />
          <Route path="/preferences" element={<NewsletterPreferences />} />
          <Route path="/admin/creator-health" element={<AdminCreatorHealth />} />
          <Route path="/admin/lead-finder" element={<AdminLeadFinder />} />
          <Route path="/admin/click-analytics" element={<AdminClickAnalytics />} />
          <Route path="/admin/health-checks" element={<AdminHealthChecks />} />
          <Route path="/admin/lifecycle-emails" element={<AdminLifecycleEmails />} />
          <Route path="/admin/playbooks" element={<AdminPlaybooks />} />
          <Route path="/admin/vetting-log" element={<AdminVettingLog />} />
          <Route path="/admin/manual-payouts" element={<AdminManualPayouts />} />
          <Route path="/docs/webhooks" element={<DocsWebhooks />} />
      <Route path="/dashboard/quickstart/api" element={<ApiCreatorQuickstart />} />
          <Route path="/admin/email-delivery" element={<AdminEmailDelivery />} />
          <Route path="/admin/checkout-failures" element={<AdminCheckoutFailures />} />
          <Route path="/admin/partner-applications" element={<AdminPartnerApplications />} />
          <Route path="/admin/prospects" element={<AdminProspects />} />
          <Route path="/admin/affiliate-partners" element={<AdminAffiliatePartners />} />
          <Route path="/admin/spotlight-calendar" element={<AdminSpotlightCalendar />} />
          <Route path="/admin/partner-revenue" element={<AdminPartnerRevenue />} />
          <Route path="/admin/inventor-notebook" element={<AdminInventorNotebook />} />
          <Route path="/admin/platform-partners" element={<AdminPlatformPartners />} />
          <Route path="/admin/outreach" element={<AdminOutreach />} />
          <Route path="/admin/upgrade-candidates" element={<AdminUpgradeCandidates />} />
          <Route path="/admin/outreach-log" element={<AdminOutreachLog />} />
          <Route path="/admin/seo-audits" element={<AdminSEOAudits />} />
          <Route path="/admin/build-partner-applications" element={<AdminBuildPartnerApplications />} />
          <Route path="/admin/optimizer-funnel" element={<AdminOptimizerFunnel />} />
          <Route path="/admin/memes" element={<AdminMemes />} />
          <Route path="/admin/compliance" element={<AdminCompliance />} />
          <Route path="/admin/influencers" element={<AdminInfluencers />} />
          <Route path="/admin/avatar-tool" element={<AdminAvatarTool />} />
          <Route path="/admin/product-image-tool" element={<AdminProductImageTool />} />
          <Route path="/admin/user-merge-tool" element={<AdminUserMergeTool />} />
      <Route path="/admin/data-sync-tool" element={<AdminDataSyncTool />} />
          <Route path="/admin/house-products/weekly" element={<AdminHouseProductsWeekly />} />
          <Route path="/admin/products-manager" element={<AdminProductManager />} />
          <Route path="/admin/fix-neon-products" element={<AdminFixNeonProducts />} />
          <Route path="/admin/share-cards" element={<AdminShareCards />} />
          <Route path="/admin/wave2-ops" element={<AdminWave2Ops />} />
          <Route path="/admin/commission-feed" element={<AdminCommissionFeed />} />
          <Route path="/partners/platforms" element={<PartnersPlatforms />} />
          <Route path="/partners/platforms/apply" element={<PartnersPlatformsApply />} />
          <Route path="/partners/platforms/:slug/stats" element={<PlatformPartnerStats />} />
          <Route path="/build-partners/apply" element={<BuildPartnersApply />} />
          <Route path="/optimizer" element={<Optimizer />} />
          <Route path="/press" element={<Press />} />
          <Route path="/security" element={<Security />} />
          <Route path="/legal/dmca" element={<LegalDMCA />} />
          <Route path="/privacy/request-my-data" element={<PrivacyRequestMyData />} />
          <Route path="/r/:slug" element={<InfluencerRedirect />} />
          <Route path="/founder-affiliate/agreement/:token" element={<FounderAffiliateAgreement />} />
          <Route path="/influencer/signup" element={<InfluencerLogin />} />
          <Route path="/influencer/login" element={<InfluencerLogin />} />
          <Route path="/influencer/dashboard" element={<InfluencerDashboard />} />
          <Route path="/admin-legacy" element={<AdminDashboard />} />
          <Route path="/admin-dashboard" element={<Navigate to="/admin-legacy" replace />} />
          <Route path="/partners/apply" element={<PartnerApply />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/partner-dashboard" element={<PartnerDashboard />} />
          <Route path="/submit" element={<Submit />} />
          <Route path="/creators/product-hunt" element={<ProductHuntLanding />} />
          <Route path="/sell" element={<Navigate to="/submit" replace />} />
          <Route path="/list" element={<Navigate to="/submit" replace />} />
          <Route path="/apply" element={<Navigate to="/submit" replace />} />
          <Route path="/go/:slug" element={<AffiliateGoRedirect />} />
          <Route path="/qr/:slug" element={<QrPostcardRedirect />} />
          <Route path="/admin/qr-codes" element={<AdminQRCodes />} />
          <Route path="/featured" element={<FeaturedDirectory />} />
          <Route path="/featured/:slug" element={<AffiliatePartnerStore />} />
          <Route path="/weekly" element={<WeeklyDigestIndex />} />
          <Route path="/weekly/:slug" element={<WeeklyDigest />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/badge" element={<CreatorBadge />} />
          <Route path="/leaderboard" element={<CreatorLeaderboard />} />
          <Route path="/share-helper" element={<ShareHelper />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="*" element={<BrandedSlugFallback><ComingSoon /></BrandedSlugFallback>} />
        </Routes>
      );
    }
    // Auth-required paths for regular logged-in users
    else if (isAuthPath && isLoggedIn) {
      // Fall through to full route set below
    }
    // Everyone else: Coming Soon countdown page
    else {
      return (
        <Routes>
          <Route path="/" element={<ComingSoon />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/founder-affiliate/agreement/:token" element={<FounderAffiliateAgreement />} />
          <Route path="*" element={<BrandedSlugFallback><ComingSoon /></BrandedSlugFallback>} />
        </Routes>
      );
    }
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/coming-soon" element={<ComingSoon />} />
      {/* Legacy `/category/*` URLs Google indexed long ago — 301-style
          client redirect to the live homepage hash so old social links
          still land somewhere useful + robots.txt now blocks crawling. */}
      <Route path="/category" element={<Navigate to="/#categories" replace />} />
      <Route path="/category/:slug" element={<Navigate to="/#categories" replace />} />
      {/* Dedicated search route so the SearchAction schema placeholder
          can't collide with the homepage. Search itself happens on /. */}
      <Route path="/search" element={<Navigate to="/" replace />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/store/:creatorSlug" element={<CreatorStore />} />
      <Route path="/product/:productId" element={<ProductDetail />} />
      <Route path="/dashboard" element={<DashboardRouter />} />
      <Route path="/marketplace-preview" element={<MarketplacePreview />} />
      <Route path="/profile" element={<BuyerProfile />} />
      <Route path="/my-purchases" element={<MyPurchases />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/checkout/success" element={<CheckoutSuccess />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/set-password" element={<SetPassword />} />
      <Route path="/badge" element={<CreatorBadge />} />
      <Route path="/leaderboard" element={<CreatorLeaderboard />} />
      <Route path="/share-helper" element={<ShareHelper />} />
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/faqs" element={<FAQs />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/messages" element={<Messages />} />
      <Route path="/chat" element={<ChatRooms />} />
      <Route path="/chat/:roomId" element={<ChatRooms />} />
      <Route path="/discover" element={<Discover />} />
      {/* Admin Console Routes */}
      <Route path="/admin" element={<AdminOverview />} />
      <Route path="/admin/fraud" element={<AdminFraud />} />
      <Route path="/admin/disputes" element={<AdminDisputes />} />
      <Route path="/admin/refunds" element={<AdminRefunds />} />
      <Route path="/admin/audit-logs" element={<AdminAuditLogs />} />
      <Route path="/admin/security/blocked-ips" element={<AdminSecurityBlockedIPs />} />
      <Route path="/preferences" element={<NewsletterPreferences />} />
      <Route path="/admin/creator-health" element={<AdminCreatorHealth />} />
      <Route path="/admin/lead-finder" element={<AdminLeadFinder />} />
      <Route path="/admin/playbooks" element={<AdminPlaybooks />} />
      <Route path="/admin/vetting-log" element={<AdminVettingLog />} />
      <Route path="/admin/manual-payouts" element={<AdminManualPayouts />} />
      <Route path="/docs/webhooks" element={<DocsWebhooks />} />
      <Route path="/dashboard/quickstart/api" element={<ApiCreatorQuickstart />} />
      <Route path="/admin/email-delivery" element={<AdminEmailDelivery />} />
      <Route path="/admin/checkout-failures" element={<AdminCheckoutFailures />} />
      <Route path="/admin/partner-applications" element={<AdminPartnerApplications />} />
      <Route path="/admin/prospects" element={<AdminProspects />} />
      <Route path="/admin/affiliate-partners" element={<AdminAffiliatePartners />} />
      <Route path="/admin/spotlight-calendar" element={<AdminSpotlightCalendar />} />
      <Route path="/admin/partner-revenue" element={<AdminPartnerRevenue />} />
      <Route path="/admin/inventor-notebook" element={<AdminInventorNotebook />} />
      <Route path="/admin/platform-partners" element={<AdminPlatformPartners />} />
      <Route path="/admin/outreach" element={<AdminOutreach />} />
      <Route path="/admin/upgrade-candidates" element={<AdminUpgradeCandidates />} />
      <Route path="/admin/outreach-log" element={<AdminOutreachLog />} />
      <Route path="/admin/seo-audits" element={<AdminSEOAudits />} />
      <Route path="/admin/build-partner-applications" element={<AdminBuildPartnerApplications />} />
      <Route path="/admin/optimizer-funnel" element={<AdminOptimizerFunnel />} />
      <Route path="/admin/memes" element={<AdminMemes />} />
      <Route path="/admin/compliance" element={<AdminCompliance />} />
      <Route path="/admin/influencers" element={<AdminInfluencers />} />
      <Route path="/admin/avatar-tool" element={<AdminAvatarTool />} />
      <Route path="/admin/product-image-tool" element={<AdminProductImageTool />} />
      <Route path="/admin/user-merge-tool" element={<AdminUserMergeTool />} />
      <Route path="/admin/data-sync-tool" element={<AdminDataSyncTool />} />
      <Route path="/admin/house-products/weekly" element={<AdminHouseProductsWeekly />} />
      <Route path="/admin/products-manager" element={<AdminProductManager />} />
      <Route path="/admin/fix-neon-products" element={<AdminFixNeonProducts />} />
      <Route path="/admin/share-cards" element={<AdminShareCards />} />
      <Route path="/admin/wave2-ops" element={<AdminWave2Ops />} />
      <Route path="/r/:slug" element={<InfluencerRedirect />} />
      <Route path="/founder-affiliate/agreement/:token" element={<FounderAffiliateAgreement />} />
      <Route path="/influencer/signup" element={<InfluencerLogin />} />
      <Route path="/influencer/login" element={<InfluencerLogin />} />
      <Route path="/influencer/dashboard" element={<InfluencerDashboard />} />
      <Route path="/admin/commission-feed" element={<AdminCommissionFeed />} />
      {/* Click Analytics + Health Checks were previously only registered in
          the "Public paths" route block, so when an admin was logged in
          (which triggers `canPreviewMarketplace` and falls through to this
          main route set), React Router silently rendered nothing — the
          page looked completely blank with a "No routes matched" warning
          in the console. Registering them here too closes that gap. */}
      <Route path="/admin/click-analytics" element={<AdminClickAnalytics />} />
      <Route path="/admin/health-checks" element={<AdminHealthChecks />} />
      <Route path="/admin/lifecycle-emails" element={<AdminLifecycleEmails />} />
      <Route path="/build-partners/apply" element={<BuildPartnersApply />} />
      <Route path="/optimizer" element={<Optimizer />} />
      <Route path="/partners/platforms" element={<PartnersPlatforms />} />
      <Route path="/partners/platforms/apply" element={<PartnersPlatformsApply />} />
      <Route path="/partners/platforms/:slug/stats" element={<PlatformPartnerStats />} />
      <Route path="/press" element={<Press />} />
      <Route path="/security" element={<Security />} />
      <Route path="/legal/dmca" element={<LegalDMCA />} />
      <Route path="/privacy/request-my-data" element={<PrivacyRequestMyData />} />
      <Route path="/admin-legacy" element={<AdminDashboard />} />
      <Route path="/admin-dashboard" element={<Navigate to="/admin-legacy" replace />} />
      <Route path="/partners/apply" element={<PartnerApply />} />
      <Route path="/partners" element={<Partners />} />
      <Route path="/partner-dashboard" element={<PartnerDashboard />} />
      <Route path="/submit" element={<Submit />} />
      <Route path="/creators/product-hunt" element={<ProductHuntLanding />} />
      <Route path="/sell" element={<Navigate to="/submit" replace />} />
      <Route path="/list" element={<Navigate to="/submit" replace />} />
      <Route path="/apply" element={<Navigate to="/submit" replace />} />
      <Route path="/go/:slug" element={<AffiliateGoRedirect />} />
      <Route path="/qr/:slug" element={<QrPostcardRedirect />} />
      <Route path="/admin/qr-codes" element={<AdminQRCodes />} />
      <Route path="/featured" element={<FeaturedDirectory />} />
      <Route path="/featured/:slug" element={<AffiliatePartnerStore />} />
      <Route path="/weekly" element={<WeeklyDigestIndex />} />
      <Route path="/weekly/:slug" element={<WeeklyDigest />} />
      {/* New backlog feature routes */}
      <Route path="/wishlist" element={<Wishlist />} />
      <Route path="/blog" element={<Navigate to="/resources" replace />} />
      <Route path="/blog/:slug" element={<Navigate to="/resources" replace />} />
      <Route path="/seller/analytics" element={<SellerAnalytics />} />
      <Route path="/affiliate/payouts" element={<AffiliatePayouts />} />
      <Route path="/affiliate/program" element={<AffiliateProgram />} />
      <Route path="/my-disputes" element={<MyDisputes />} />
      <Route path="/seller/disputes" element={<SellerDisputes />} />
      <Route path="/my-subscriptions" element={<MySubscriptions />} />
      <Route path="/referrals" element={<ReferralDashboard />} />
      <Route path="/resources" element={<Resources />} />
    </Routes>
  );
}

function AppContent() {
  const [siteMode, setSiteMode] = useState('live');
  
  useEffect(() => {
    const checkSiteMode = async () => {
      try {
        const response = await axios.get('/site-mode');
        setSiteMode(response.data.mode);
      } catch (error) {
        setSiteMode('live');
      }
    };
    checkSiteMode();
  }, []);

  return (
    <>
      {/* ScrollToTop superseded by <ScrollRestoration /> in App() — handles
          POP/PUSH/REPLACE in one place with rAF-gated restore. */}
      <AppRouter />
      {siteMode !== 'coming_soon' && <LaunchDayBar />}
      {siteMode !== 'coming_soon' && <FloatingChatbot />}
      {siteMode !== 'coming_soon' && <ScoutFloatingButton />}
      {siteMode !== 'coming_soon' && <CookieConsent />}
      <PWAInstallPrompt />
      <EmailCapturePopup />
    </>
  );
}

function App() {
  // Register PWA service worker on mount
  useEffect(() => {
    registerServiceWorker();
  }, []);

  return (
    <div className="App min-h-screen bg-[#050505]">
      <ErrorBoundary>
        <BrowserRouter>
          <ScrollRestoration />
          <InAppBrowserBanner />
          <AppContent />
        </BrowserRouter>
      </ErrorBoundary>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
